$(function () {
    var subscriptionFormContainer = document.querySelector('#ms-form--container');
    var toggleSubscriptionButtons = document.querySelectorAll('button[ms-toggle-id]');
    var allSubscriptionElements = document.querySelectorAll('div[ms-id]');
    var allSubscriptionSelectElements = document.querySelectorAll('select.ms-select-subscription');

    if (allSubscriptionElements == null || allSubscriptionElements.length === 0) return;

    var currentSubscriptionElement = allSubscriptionElements[0];

    function showSubscriptionElement(subscriptionElement) {
        if (currentSubscriptionElement) {
            currentSubscriptionElement.classList.add('d-none');

            var currentSubscriptionSelectElement = currentSubscriptionElement.querySelector(
                'select.ms-select-subscription'
            );
            if (currentSubscriptionSelectElement) {
                currentSubscriptionSelectElement.value =
                    currentSubscriptionElement.getAttribute('ms-id');
            }
        }

        subscriptionElement.classList.remove('d-none');
        currentSubscriptionElement = subscriptionElement;
    }

    toggleSubscriptionButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            var targetId = parseInt(button.getAttribute('ms-toggle-id'));
            showSubscriptionElement(allSubscriptionElements[targetId]);

            if (subscriptionFormContainer) {
                const y =
                    subscriptionFormContainer.getBoundingClientRect().top + window.scrollY + -100; // -100 for offsetting the menu

                window.scrollTo({ top: y, behavior: 'smooth' });
            }
        });
    });

    allSubscriptionSelectElements.forEach(function (select) {
        select.addEventListener('change', function () {
            var targetId = parseInt(select.value);

            if (
                targetId === -1 ||
                targetId === parseInt(currentSubscriptionElement.getAttribute('ms-id'))
            )
                return;

            showSubscriptionElement(allSubscriptionElements[targetId]);
        });
    });
});
